import OrganizationFormUser from '../organizationFormUser/organizationFormUser'


function Navbar({ setShowSpinner }) {
  return (
    <>
      <div className='mt-2'>
        <OrganizationFormUser setShowSpinner={setShowSpinner} />
      </div>
    </>
  );
}

export default Navbar;
